import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [statusMessage, setStatusMessage] = useState('Completing sign in...');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      try {
        // Get session from Supabase (handles OAuth callback automatically)
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          navigate('/auth', { replace: true });
          return;
        }

        if (!session?.user) {
          // No session, redirect to auth
          navigate('/auth', { replace: true });
          return;
        }

        const user = session.user;
        setStatusMessage('Syncing your account...');

        // Sync user with backend
        try {
          await fetch(`${API}/api/auth/supabase-sync`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              supabase_user_id: user.id,
              email: user.email,
              full_name: user.user_metadata?.full_name || user.email?.split('@')[0],
            }),
          });
        } catch (syncError) {
          console.error('User sync error:', syncError);
        }

        // Check for saved redirect path
        const savedRedirect = localStorage.getItem('redirectAfterAuth') || '/dashboard';
        localStorage.removeItem('redirectAfterAuth');
        
        navigate(savedRedirect, { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#192A3F] to-[#0F1E2D] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF9E00] mx-auto mb-4"></div>
        <p className="text-white/80">{statusMessage}</p>
      </div>
    </div>
  );
}
